webpackJsonp([134082455631005],{

/***/ 240:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.CommonPageHeader = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _pageHeader = __webpack_require__(19);
	
	var _pageNav = __webpack_require__(27);
	
	var _newsAndEventsManager = __webpack_require__(219);
	
	var _globalStyles = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommonPageHeader = exports.CommonPageHeader = function CommonPageHeader(_ref) {
		var activeItem = _ref.activeItem;
		return _react2.default.createElement(_pageHeader.PageHeader, {
			background: _globalStyles.blue,
			titleText: 'Blog and Podcast',
			titleTextColor: '#fff',
			pageNav: _react2.default.createElement(_pageNav.PageNav, {
				textColor: '#fff',
				activeTextColor: '#fff',
				activeUnderlineColor: _globalStyles.aqua,
				links: [{
					to: (0, _newsAndEventsManager.linkWithFilter)({ base: 'blog-and-podcast' }),
					text: 'Featured',
					isActive: function isActive() {
						return activeItem === 'blog-and-podcast';
					}
				}, {
					to: (0, _newsAndEventsManager.linkWithFilter)({ base: 'blog' }),
					text: 'Blog',
					isActive: function isActive() {
						return activeItem === 'blog';
					}
				}, {
					to: (0, _newsAndEventsManager.linkWithFilter)({ base: 'podcasts' }),
					text: 'Podcasts',
					isActive: function isActive() {
						return activeItem === 'podcasts';
					}
				}]
			})
		});
	};
	
	CommonPageHeader.propTypes = {
		activeItem: _propTypes2.default.string
	};

/***/ }),

/***/ 241:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _component = __webpack_require__(240);
	
	Object.keys(_component).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _component[key];
	    }
	  });
	});

/***/ }),

/***/ 461:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.FeaturedCard = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _dateManager = __webpack_require__(62);
	
	var _link = __webpack_require__(9);
	
	var _audienceIcon = __webpack_require__(105);
	
	var _audienceIcon2 = _interopRequireDefault(_audienceIcon);
	
	var _styles = __webpack_require__(463);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FeaturedCardComponent = function (_React$PureComponent) {
		_inherits(FeaturedCardComponent, _React$PureComponent);
	
		function FeaturedCardComponent() {
			_classCallCheck(this, FeaturedCardComponent);
	
			return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
		}
	
		FeaturedCardComponent.prototype.render = function render() {
			var _props = this.props,
			    to = _props.to,
			    audiences = _props.audiences,
			    title = _props.title,
			    date = _props.date,
			    background = _props.background;
	
	
			return _react2.default.createElement(
				_link.Link,
				{ className: _styles.wrapperLinkStyle, to: to, 'data-component': 'Card' },
				_react2.default.createElement(
					'article',
					{ className: (0, _styles.wrapperStyle)(background) },
					_react2.default.createElement(
						'div',
						{ className: _styles.wrapperInnerStyle },
						audiences && _react2.default.createElement(
							'div',
							{ className: _styles.metaAudiencesStyle },
							audiences.map(function (audience) {
								return _react2.default.createElement(_audienceIcon2.default, { key: audience.id, audience: audience, size: 12 });
							})
						),
						_react2.default.createElement(
							'h1',
							{ className: _styles.titleStyle },
							title
						),
						_react2.default.createElement(
							'p',
							{ className: _styles.metaDateStyle },
							(0, _dateManager.format)(date)
						)
					)
				)
			);
		};
	
		return FeaturedCardComponent;
	}(_react2.default.PureComponent);
	
	FeaturedCardComponent.propTypes = {
		to: _propTypes2.default.string,
		category: _propTypes2.default.string,
		audiences: _propTypes2.default.array,
		title: _propTypes2.default.string,
		body: _propTypes2.default.string,
		date: _propTypes2.default.string,
		views: _propTypes2.default.number,
		background: _propTypes2.default.string,
		hasVideo: _propTypes2.default.bool
	};
	
	var FeaturedCard = exports.FeaturedCard = FeaturedCardComponent;

/***/ }),

/***/ 462:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _component = __webpack_require__(461);
	
	Object.keys(_component).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _component[key];
	    }
	  });
	});

/***/ }),

/***/ 463:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.wrapperStyle = exports.wrapperInnerStyle = exports.metaDateStyle = exports.titleStyle = exports.metaCategoryStyle = exports.metaAudiencesStyle = exports.wrapperLinkStyle = undefined;
	
	var _css, _css2;
	
	var _emotion = __webpack_require__(6);
	
	var _globalStyles = __webpack_require__(4);
	
	var wrapperLinkStyle = /*#__PURE__*/exports.wrapperLinkStyle = (0, _emotion.css)({
		textDecoration: 'none',
		display: 'table',
		width: '100%'
	});
	
	var metaAudiencesStyle = /*#__PURE__*/exports.metaAudiencesStyle = (0, _emotion.css)({
		marginBottom: '30px',
		'& svg:not(:last-child)': {
			marginRight: '6px'
		}
	});
	
	var metaCategoryStyle = /*#__PURE__*/exports.metaCategoryStyle = (0, _emotion.css)((_css = {
		textTransform: 'uppercase',
		color: _globalStyles.grey,
		fontWeight: 'bold',
		fontSize: '12px',
		marginBottom: '14px',
		marginTop: '41px'
	}, _css['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		marginTop: '24px'
	}, _css));
	
	var titleStyle = exports.titleStyle = (0, _emotion.cx)(_globalStyles.headingMedium, /*#__PURE__*/(0, _emotion.css)((_css2 = {
		color: '#fff',
		marginBottom: '12px'
	}, _css2['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		fontSize: '16px',
		lineHeight: '19px'
	}, _css2)));
	
	var metaDateStyle = /*#__PURE__*/exports.metaDateStyle = (0, _emotion.css)({
		fontSize: '14px',
		lineHeight: '17px',
		color: '#fff',
		margin: '0'
	});
	
	var wrapperInnerStyle = /*#__PURE__*/exports.wrapperInnerStyle = (0, _emotion.css)({
		position: 'relative',
		zIndex: '1'
	});
	
	var wrapperStyle = exports.wrapperStyle = function wrapperStyle(background) {
		var _css3;
	
		return (/*#__PURE__*/(0, _emotion.css)((_css3 = {
				display: 'table-cell',
				verticalAlign: 'bottom',
				textDecoration: 'none',
				border: '1px solid ' + _globalStyles.lightGrey,
				borderRadius: '6px',
				width: '100%',
				height: '306px',
				padding: '24px',
				backgroundImage: 'url(' + background + ')',
				backgroundRepeat: 'no-repeat',
				backgroundPosition: 'center center',
				backgroundSize: 'cover',
				boxSizing: 'content-box',
				zIndex: '1',
				position: 'relative',
				'&:after': {
					position: 'absolute',
					top: '0',
					left: '0',
					opacity: '0.6',
					width: '100%',
					height: '100%',
					display: 'block',
					content: '" "',
					background: '#000',
					borderRadius: '6px'
				}
			}, _css3['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
				height: '200px',
				padding: '15px'
			}, _css3))
		);
	};

/***/ }),

/***/ 174:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageControlsStyle = exports.rightStyle = exports.leftStyle = exports.filtersInnerWrapperStyle = exports.filtersWrapperStyle = exports.wrapperStyle = exports.rightSearchStyle = exports.mobileSearchStyle = exports.mobileFiltersDropDownStyle = exports.mobileFiltersStyle = exports.innerWrapperStyle = exports.featuredCardSectionStyle = exports.subTitleStyle = undefined;
	
	var _css, _css2, _css3, _dataComponentFi, _dataComponentSi, _css4, _css5;
	
	var _emotion = __webpack_require__(6);
	
	var _globalStyles = __webpack_require__(4);
	
	var subTitleStyle = exports.subTitleStyle = (0, _emotion.cx)(_globalStyles.headingMediumLight, /*#__PURE__*/(0, _emotion.css)((_css = {}, _css['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		fontSize: '16px',
		lineHeight: '18px'
	}, _css)));
	
	var featuredCardSectionStyle = /*#__PURE__*/exports.featuredCardSectionStyle = (0, _emotion.css)({
		margin: '60px 0',
		'& header': {
			marginBottom: '25px'
		}
	});
	
	var innerWrapperStyle = /*#__PURE__*/exports.innerWrapperStyle = (0, _emotion.css)({
		maxWidth: _globalStyles.desktopMaxWidthBreakpoint,
		width: '100%',
		height: '100%',
		margin: '0 auto',
		padding: '0 20px',
		position: 'relative'
	});
	
	var mobileFiltersStyle = exports.mobileFiltersStyle = _globalStyles.sideBarLayout.mobileFilters;
	
	var mobileFiltersDropDownStyle = /*#__PURE__*/exports.mobileFiltersDropDownStyle = (0, _emotion.css)({
		position: 'relative',
		boxShadow: 'rgba(0,0,0,0.09) 0 6px 12px 0',
		background: '#fff',
		zIndex: '3',
		padding: '20px'
	});
	
	var mobileSearchStyle = /*#__PURE__*/exports.mobileSearchStyle = (0, _emotion.css)((_css2 = {
		display: 'none !important'
	}, _css2['@media (max-width: ' + _globalStyles.tabletPortraitMaxWidthBreakpoint + 'px)'] = {
		display: 'block !important'
	}, _css2));
	
	var rightSearchStyle = /*#__PURE__*/exports.rightSearchStyle = (0, _emotion.css)((_css3 = {
		display: 'block'
	}, _css3['@media (max-width: ' + _globalStyles.tabletPortraitMaxWidthBreakpoint + 'px)'] = {
		display: 'none'
	}, _css3));
	
	var wrapperStyle = exports.wrapperStyle = _globalStyles.sideBarLayout.wrapper;
	
	var filtersWrapperStyle = /*#__PURE__*/exports.filtersWrapperStyle = (0, _emotion.css)({
		borderBottom: '1px solid ' + _globalStyles.lightGrey
	});
	
	var filtersInnerWrapperStyle = /*#__PURE__*/exports.filtersInnerWrapperStyle = (0, _emotion.css)((_css4 = {
		maxWidth: _globalStyles.desktopMaxWidthBreakpoint,
		width: '100%',
		height: '74px',
		margin: '0 auto',
		padding: '0 20px',
		display: 'flex',
		justifyContent: 'flex-end',
		alignItems: 'center'
	
	}, _css4['@media (max-width: ' + _globalStyles.desktopMaxWidthBreakpoint + 'px)'] = {
		justifyContent: 'space-between'
	}, _css4['@media (max-width: ' + _globalStyles.tabletPortraitMaxWidthBreakpoint + 'px)'] = {
		justifyContent: 'flex-start'
	}, _css4['& [data-component=FilterDropDown]'] = (_dataComponentFi = {
		display: 'none'
	}, _dataComponentFi['@media (max-width: ' + _globalStyles.desktopMaxWidthBreakpoint + 'px)'] = {
		display: 'block',
		marginRight: '20px'
	}, _dataComponentFi), _css4['& [data-component=SingleFieldForm]'] = (_dataComponentSi = {}, _dataComponentSi['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		'& input': {
			width: 'calc(100% - 46px)'
		}
	}, _dataComponentSi), _css4));
	
	var leftStyle = exports.leftStyle = _globalStyles.sideBarLayout.leftSide(0);
	
	var rightStyle = exports.rightStyle = _globalStyles.sideBarLayout.rightSide(0);
	
	var pageControlsStyle = /*#__PURE__*/exports.pageControlsStyle = (0, _emotion.css)((_css5 = {
		display: 'table',
		width: '100%',
		'& p': {
			display: 'table-cell',
			width: '100%',
			color: _globalStyles.darkGrey,
			fontSize: '16px',
			lineHeight: '19px'
		},
		'& > div': {
			display: 'table-cell'
		}
	}, _css5['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		'& p, & > div': {
			display: 'block'
		}
	}, _css5));

/***/ }),

/***/ 1083:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _audienceManager = __webpack_require__(121);
	
	var _navManager = __webpack_require__(22);
	
	var _cards = __webpack_require__(17);
	
	var _featuredCard = __webpack_require__(462);
	
	var _resourceCard = __webpack_require__(30);
	
	var _commonPageHeader = __webpack_require__(241);
	
	var _blogAndPodcast = __webpack_require__(174);
	
	var _globalStyles = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BlogTilePropType = _propTypes2.default.shape({
		id: _propTypes2.default.string.isRequired,
		title: _propTypes2.default.string.isRequired,
		date: _propTypes2.default.string.isRequired,
		extract: _propTypes2.default.string.isRequired,
		fields: _propTypes2.default.shape({
			thumbnail_image: _propTypes2.default.shape({
				childImageSharp: _propTypes2.default.shape({
					resize: _propTypes2.default.shape({
						src: _propTypes2.default.string.isRequired
					}).isRequired
				}).isRequired
			}).isRequired
		}).isRequired
	});
	
	var BlogAndPodcastPage = function (_React$PureComponent) {
		_inherits(BlogAndPodcastPage, _React$PureComponent);
	
		function BlogAndPodcastPage() {
			_classCallCheck(this, BlogAndPodcastPage);
	
			return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
		}
	
		BlogAndPodcastPage.prototype.render = function render() {
			var recentBlogPosts = this.props.data.recentBlogPosts;
	
			var pageSettings = this.props.data.page.edges[0].node;
			var featuredCard = void 0;
			var otherBlogPosts = void 0;
	
			if (pageSettings.featured_blog) {
				featuredCard = pageSettings.featured_blog;
				otherBlogPosts = recentBlogPosts.edges.filter(function (_ref) {
					var node = _ref.node;
					return node.id !== featuredCard.id;
				}).slice(0, 4);
			} else {
				featuredCard = recentBlogPosts.edges[0].node;
				otherBlogPosts = recentBlogPosts.edges.slice(1, 5);
			}
	
			return _react2.default.createElement(
				_react2.default.Fragment,
				null,
				_react2.default.createElement(
					_reactHelmet.Helmet,
					{ title: pageSettings.blue_heading },
					_react2.default.createElement('meta', { property: 'og:type', content: 'website' }),
					_react2.default.createElement('meta', { property: 'og:title', content: pageSettings.blue_heading }),
					_react2.default.createElement('meta', { name: 'description', content: 'InsideOut Blog & Podcast' }),
					_react2.default.createElement('meta', { property: 'og:description', content: 'InsideOut Blog & Podcast' })
				),
				_react2.default.createElement(_commonPageHeader.CommonPageHeader, { activeItem: 'blog-and-podcast' }),
				_react2.default.createElement(
					'div',
					{ className: _blogAndPodcast.innerWrapperStyle },
					_react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'section',
							{ className: _blogAndPodcast.featuredCardSectionStyle },
							_react2.default.createElement(
								'header',
								null,
								_react2.default.createElement(
									'h1',
									{ className: _blogAndPodcast.subTitleStyle },
									pageSettings.blue_heading
								)
							),
							_react2.default.createElement(_featuredCard.FeaturedCard, {
								audiences: (0, _audienceManager.fullAudiences)(featuredCard.audiences),
								to: (0, _navManager.idToLink)(featuredCard.id),
								title: featuredCard.title,
								date: featuredCard.date,
								background: featuredCard.fields && featuredCard.fields.thumbnail_image && featuredCard.fields.thumbnail_image.childImageSharp.resize.src
							}),
							otherBlogPosts && _react2.default.createElement(
								'div',
								{ className: (0, _globalStyles.cardSection)(14) },
								_react2.default.createElement(
									_cards.Cards,
									{ columns: 4 },
									otherBlogPosts.map(function (_ref2, index) {
										var node = _ref2.node;
										return _react2.default.createElement(_resourceCard.ResourceCard, {
											key: index,
											background: node.fields && node.fields.thumbnail_image.childImageSharp.resize.src,
											to: (0, _navManager.idToLink)(node.id),
											audiences: (0, _audienceManager.fullAudiences)(node.audiences),
											title: node.title,
											type: 'blog',
											body: node.extract,
											date: node.date
										});
									})
								)
							)
						)
					)
				)
			);
		};
	
		return BlogAndPodcastPage;
	}(_react2.default.PureComponent);
	
	BlogAndPodcastPage.propTypes = {
		data: _propTypes2.default.shape({
			page: _propTypes2.default.shape({
				edges: _propTypes2.default.arrayOf(_propTypes2.default.shape({
					node: _propTypes2.default.shape({
						blue_heading: _propTypes2.default.string.isRequired,
						featured_blog: BlogTilePropType
					})
				}))
			}),
	
			recentBlogPosts: _propTypes2.default.shape({
				edges: _propTypes2.default.arrayOf(_propTypes2.default.shape({
					node: BlogTilePropType.isRequired
				})).isRequired
			}).isRequired
		}).isRequired
	};
	exports.default = BlogAndPodcastPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-blog-and-podcast-index-js-fc96e7f8bd09661c824b.js